import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IBaseModel } from 'src/app/models/base.model';
import { IFasesAtividadeModel } from 'src/app/models/fases-atividade-model';
import { FaseAtividadeService } from 'src/app/services/fase-atividade.service';
import Swal from 'sweetalert2';
import { BaseFormComponent } from '../../shared/components/base-form/base-form.component';
import { TipoTrabalhoService } from 'src/app/services/tipo-trabalho.service';
import { ITipoTrabalhoModel } from 'src/app/models/tipo-trabalho.model';
import { AtividadeTipoTrabalhoService } from 'src/app/services/atividade-tipo-trabalho.service';
import { IAtividadeTipoTrabalhoModel } from 'src/app/models/atividade-tipo-trabalho.model';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';

@Component({
  selector: 'app-fase-atividade-form',
  templateUrl: './fase-atividade-form.component.html',
  styleUrls: ['./fase-atividade-form.component.scss']
})
export class FaseAtividadeFormComponent extends BaseFormComponent implements OnInit {
  public model: IAtividadeTipoTrabalhoModel = {} as IAtividadeTipoTrabalhoModel;
  public listaTipoTrabalho = [] as ITipoTrabalhoModel[];
  public quantidadeDias: number = 0;

  public form = new FormGroup({
    id: new FormControl({ value: '', disabled: true }),
    tipoTrabalhoId: new FormControl('', Validators.required),
    descricao: new FormControl(''),
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
    private atividadeTipoTrabalhoService: AtividadeTipoTrabalhoService,
    private tipoTrabalhoService: TipoTrabalhoService,
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.novoRegistro) {
      this.titulo = 'Novo Fase de Atividade';
    }
  }


  async ngOnInit() {
    try {
      this.carregarTiposTrabalho();
      if (!this.novoRegistro) {
        const res = await this.atividadeTipoTrabalhoService.obterPorId(this.id);
        if (res.sucesso) {
          this.model = res.dados;
          this.atualizarQuantidadeDias();
          if (this.visualizar) {
            this.titulo = 'Visualizar Fase de atividade - ' + this.model.tipoTrabalho.nome;
          }
          else {
            this.titulo = 'Editar Fase de atividade - ' + this.model.tipoTrabalho.nome;
          }

        } else {
          this.exibirMensagemErro(res.mensagem.descricao);
          this.router.navigate(['/fase-atividade']);
          return;
        }
      }
      this.form.patchValue(this.model);
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
      this.router.navigate(['/fase-atividade']);
    }
  }

  public async salvarDados(salvarEFechar: boolean) {
    this.submit = true;
    if (this.form.invalid) {
      this.exibirMensagemAlerta('Formulário inválido');
      return;
    }

    this.atualizarModel(this.form.value);

    try {
      let res: IBaseModel<void> = null;

      if (!this.novoRegistro) {
        res = await this.atividadeTipoTrabalhoService.atualizar(this.model);
      } else {
        res = await this.atividadeTipoTrabalhoService.inserir(this.model);
      }

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: 'success',
          text: res.mensagem.descricao
        });

        if (salvarEFechar == true) {
          this.router.navigate(['/fase-atividade']);
        }
        else {
          Object.assign(this.model, res.dados);
          this.router.navigate([`/fase-atividade/${this.model.id}`]);
        }
      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    }
    catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  public async carregarTiposTrabalho() {
    await this.tipoTrabalhoService
      .obter()
      .then(res => {
        if (res.sucesso)
          this.listaTipoTrabalho = res.dados;
      });
  }

  public atualizarQuantidadeDias(): void {
    this.quantidadeDias = this.model.fases?.reduce((total, fase) => total + (fase.quantidadeDias || 0), 0) || 0;
  }

  public async onSubmit() {
    this.salvarDados(false);
  }

  private atualizarModel(values: any) {
    Object.assign(this.model, values);
  }

  public onBack() {
    this.submit = false;
    if (this.form.dirty && !this.novoRegistro) {
      const dialogConfig = new MatDialogConfig();
      const modal = this.matDialog.open(ModalCancelarComponent, dialogConfig);
      modal.afterClosed().subscribe((resultado) => {
        if (resultado == true) {
          this.router.navigate(['/fase-atividade']);
        }
      });
    } else {
      this.router.navigate(['/fase-atividade']);
    }
  }
}